import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutProcessCommissionsPostExceptionTable extends Layout {
    tableExceptions: Table;
}
